import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FormService} from '../services/form.service';
import { WavixService } from '../services/wavix.service';
import { lastValueFrom, Observable } from 'rxjs';
import { EmailvalidationService } from '../services/emailvalidation.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  form = new FormGroup({
    name: new FormControl(null, Validators.required),
    email: new FormControl(null, Validators.required),
    number_1: new FormControl("", Validators.required),
    number_2: new FormControl("", Validators.required),
    country_code_1: new FormControl("+1"),
    country_code_2: new FormControl("+1"),
    check: new FormControl(false, Validators.requiredTrue),
  });
  phone: any;
  check_wavix: any
  message: any = "";

  constructor(private api: FormService, private wavix_api: WavixService, private email_validation_api: EmailvalidationService) {
  }

  ngOnInit(): void {
    console.log("start")
  }

  async sendForm(): Promise<void> {
    this.message = "";
    this.form.markAllAsTouched();

    console.log("this.form.valid", this.form.valid);

    if (this.form.valid) {
      console.log("send");


    } else {
      console.log("no valid");
    }





    // let email = this.form.value.email
    // console.log(
    //   "email", email
    // );




    // if (this.message == "") {
    //   const response = await lastValueFrom(this.email_validation("bog@gmail"));
    //   if (response.is_valid_format.value != true) {
    //     this.message = "Please enter valid email address"
    //   }
    // }

    // if (this.message == "") {
    //   if (this.form?.value) {
    //     const { country_code_1, number_1, country_code_2, number_2 } = this.form.value;

    //     if (country_code_1 && number_1 && country_code_2 && number_2) {
    //       if (country_code_1 + number_1 !== country_code_2 + number_2) {
    //         this.message = "The entered phone numbers are not the same. Please try filling in the phone number fields again.";
    //       }
    //     } else {
    //       this.message = "Please fill in both phone number fields.";
    //     }
    //   }
    // }

    // if (this.message == "") {
    //   try {
    //     const response = await lastValueFrom(this.wavix_phone_validation("+38068645114"));
    //     console.log("response:::", response);

    //     if (response.valid != true) {
    //       console.log("error");
    //       this.message = "Please enter the correct phone number"
    //     } else {
    //       console.log("validation success");
    //     }
    //   } catch (error) {
    //     console.log("error during validation", error);
    //   }
    // }


    // const elements = document.querySelectorAll('.selected-flag');
    // elements.forEach((element, index) => {
    //   const selectedFlag = element.getAttribute('title');

    //   if (selectedFlag) {
    //     const parts = selectedFlag.split(':');
    //     if (parts.length > 1) {
    //       const countryCode = parts[1].trim();

    //       if (index === 0) {
    //         this.form.patchValue({
    //           country_code_1: countryCode
    //         });
    //       } else if (index === 1) {
    //         this.form.patchValue({
    //           country_code_2: countryCode
    //         });
    //       }
    //     }
    //   }
    // });

    // console.log("Start send form !å")
    // console.log("Form:", this.form.value);



    // this.form_incoming_data_leave_us_your_phone_number(
    //   "1574",
    //   "Adrian Test",
    //   "adrian@gotyourbacksupport.com",
    //   "+380686451146",
    //   "+380686451146",
    //   "+03:00",
    //   "https://premium.gotyourbacksupport.com/leave-us-phone/",
    //   "+380",
    //   "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/128.0.0.0 Safari/537.36",
    //   "168.119.213.51"
    // )



  }

  set_country(): void {
    console.log("yes");
    console.log("yes !!!!!!!!!!!!!!!!!!!!!!");
  }

  form_incoming_data_leave_us_your_phone_number = (
    id_form: any,
    name: any,
    email: any,
    phone1: any,
    phone2: any,
    timezone: any,
    url: any,
    country_code: any,
    browser: any,
    ip: any,
  ) => {
    this.api.form_incoming_data_leave_us_your_phone_number(
      id_form,
      name,
      email,
      phone1,
      phone2,
      timezone,
      url,
      country_code,
      browser,
      ip,
    ).subscribe(
      data => {
        console.log(data);
        this.phone = data.data;
      },
      error => {
        console.log(error);

      }
    );
  }

  wavix_phone_validation = (phone_number: any): Observable<any> => {
    return this.wavix_api.wavix_phone_validation(phone_number);
  }


  email_validation = (email: any): Observable<any> => {
    return this.email_validation_api.email_validation(email);
  }

}
